<template>
	<div>
		<table class="tableBiao">
			<thead class="thead">
				<tr class="thead-tr">
					<td>姓名</td>
					<td>时间</td>
					<td style="color: #FFFFFF;">金额(元)</td>
					<td>捐赠方式</td>
					<td>捐赠类别</td>
					<td>备注</td>
				</tr>
			</thead>
			<tbody class="tbody">
				<div class="trs" :style="pos">
					<tr class="tbody-tr" v-for="(item,index) in tableList" :key="index">
						<td :title="item.title">{{item.title}}</td>
						<td>{{item.author}}</td>
						<td>{{item.subtitle}}</td>
						<td>{{item.type || '-'}}</td>
						<td :title="item.category">{{item.category || '-'}}</td>
						<td :title="item.note">{{item.note || '-'}}</td>
					</tr>
				</div>
			</tbody>
		</table>
	</div>
</template>

<script>
	import apiUrls from "@/api";
export default {
	data() {
		return {
			yPos: 0,  // 轮播到了多少距离
			tableList: [],
			//测试滚动数据
			dataList: []
		}
	},
	computed: {
		//动态监听y轴移动距离
	    pos() {
			// 计算属性改变style
	        return { transform: `translateY(${this.yPos}px` }; 
	    }
	},
	mounted() {
		this.getTable()
	},
	methods: {
		//捐款详情表
		getTable() {
			apiUrls.getList({ node: "jkxx", size: 100}).then(res => {
				if (res.rCode == 0) {
					this.tableList = res.results.data;
					//一页7条数据,如果数据长度大于7条，则不执行滚动事件
					if(this.tableList.length > 7){
						this.initScroll()
					}
				} else {
					console.log('请求失败');
				}
			});
		},
		initScroll() {
			this.$nextTick(() => {
				//为了保证数据滚动的流畅性,要复制数据的前7条(一页几条就复制几条)放到数组最后面
				var arr = this.tableList.slice(0, 7)
				let newArr =  this.tableList.concat(arr)
				this.tableList = newArr
			    setInterval(() => {
					//7是一页几条数据,55是一条数据的长度
			        if(this.yPos > -55*(this.tableList.length-7)){
			            this.yPos -= 1
			        }else{
			            this.yPos = 0
			        }
			    }, 20);
			});
		}
	}
}
</script>

<style lang="less" scoped>
	.tableBiao {
		width: 100%;
		font-size: 16px;
		color: #333333;
		display: block;
		.thead {
			display: block;
			width: 100%;
			.thead-tr {
				display: flex;
				width: 100%;
				height: 32px;
				background-color: #B60303;
				padding: 0;
				color: #FFFFFF;
				td {
					display: block;
					height: 32px;
					line-height: 32px;
					text-align: center;
				}
				td:nth-child(1) {
					width: 16%;
				}
				td:nth-child(2) {
					width: 16%;
				}
				td:nth-child(3) {
					width: 16%;
				}
				td:nth-child(4) {
					width: 12%;
				}
				td:nth-child(5) {
					width: 25%;
				}
				td:nth-child(6) {
					width: 15%;
				}
			}
		}
		.tbody {
			display: block;
			width: 100%;
			height: 385px;
			overflow: hidden;
			.trs {
				width: 100%;
				height: 100%;
			}
			.tbody-tr {
				width: 100%;
				height: 55px;
				display: flex;
				td {
					display: block;
					height: 55px;
					line-height: 55px;
					text-align: center;
				}
				td:nth-child(1) {
					width: 16%;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				td:nth-child(2) {
					width: 16%;
				}
				td:nth-child(3) {
					width: 16%;
					color: #B60303;
				}
				td:nth-child(4) {
					width: 12%;
				}
				td:nth-child(5) {
					width: 25%;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				td:nth-child(6) {
					width: 15%;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
			tr:nth-child(odd) {
			    background-color: #FFFFFF;
			}
			tr:nth-child(even) {
			     background-color: #EEEEEE;
			}
		}
		
	}
</style>
